import {
	Button,
	CardHeaderActions,
	DrawerBody,
	DrawerFooter,
	DrawerFooterActions,
	DrawerHeader,
	DrawerHeading,
	Empty,
	FormDrawerContentProps,
	SubmitButton,
} from "@dgs/core";
import { FieldArray, useFormikContext } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FilterFormValues, FilterMode } from "../filterTypes";
import { emptyQuickFilterItems } from "../utils";
import { AdvancedEventFilterForm } from "./AdvancedEventFilterForm";
import { FilterModeSwitcher } from "./FilterModeSwitcher";
import { QuickEventFilterForm } from "./QuickEventFilterForm";

export const StyledDrawerBody = styled(DrawerBody)`
	padding-left: 0;
	padding-right: 0;
`;

export const EventFilterFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();
	const { values, setFieldValue } = useFormikContext<FilterFormValues>();

	return (
		<>
			<DrawerHeader onClose={props.onClose}>
				<DrawerHeading>{props.title}</DrawerHeading>
				<CardHeaderActions>
					<FilterModeSwitcher name="mode" color="background" />
				</CardHeaderActions>
			</DrawerHeader>
			<StyledDrawerBody>
				<FieldArray
					name="filterItems"
					render={(arrayHelpers) =>
						values.mode === FilterMode.ADVANCED ? (
							<AdvancedEventFilterForm
								name={arrayHelpers.name}
								unshift={arrayHelpers.unshift}
								remove={arrayHelpers.remove}
							/>
						) : (
							<QuickEventFilterForm />
						)
					}
				/>
				{values.mode === FilterMode.ADVANCED && !values.filterItems.length && (
					<Empty>{t("No filter items available")}</Empty>
				)}
			</StyledDrawerBody>
			<DrawerFooter>
				<DrawerFooterActions>
					<Button
						type="button"
						title={t("Reset")}
						onClick={() =>
							setFieldValue("filterItems", values.mode === FilterMode.ADVANCED ? [] : emptyQuickFilterItems)
						}
					>
						{t("Reset")}
					</Button>
				</DrawerFooterActions>
				<SubmitButton title={t("Apply")}>{t("Apply")}</SubmitButton>
			</DrawerFooter>
		</>
	);
};
